export default {"src":"/_next/static/media/moonbeam-icon-new.d891a26c.svg","height":395,"width":395,"blurWidth":0,"blurHeight":0};